import {
  WorkItemServiceProvider,
  vsProviderName as WorkItemServiceProviderName,
} from "..";
import { WorkItemTypeDateController } from "./controller";

dateConfig.$inject = ["formlyConfigProvider", WorkItemServiceProviderName];
export function dateConfig(
  formlyConfigProvider: AngularFormly.IFormlyConfig,
  workItemServiceProvider: WorkItemServiceProvider,
) {
  workItemServiceProvider.addWorkItemType({
    name: "Date",
    formlyFieldType: "processDate",
  });

  formlyConfigProvider.setType({
    name: "processDate",
    template: require("!html-loader!./index.html").default,
    controller: WorkItemTypeDateController,
  });
}
